import { TableColumn } from '/@/modules/core/table/models/TableColumn';

export const FormInputMixin = {
  emits: ['on-enter', 'on-key-up', 'on-blur'],
  props: {
    column: { type: TableColumn },
    readOnly: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
    placeholder: { type: String },
    label: { type: String },
    showTooltip: { type: Boolean, default: false },
    showSelectedCount: { type: Boolean, default: false },
    isRequiredOverride: { type: Boolean, default: null },
    showFloatLabel: { type: Boolean, default: true },
    name: { type: String },
    rules: { type: [String, Object] },
    // Specifies the minimum number of characters allowed in the text area
    minLength: { type: Number, default: null },
    // Specifies the maximum number of characters allowed in the text area
    maxLength: { type: Number, default: null },
    // Tooltip to show for field, this will override tooltip in column
    tooltip: { type: String, default: null }
  },
  computed: {
    formattedLabel() {
      return this.label || this.column?.label || this.placeholder;
    },
    formattedTooltip() {
      return this.tooltip || this.column?.tooltip;
    },
    showRequiredAsterisk() {
      if (this.isRequiredOverride != null) {
        return this.isRequiredOverride;
      }
      return this.column?.is_required;
    },
    computedName() {
      return this.name || (this.column ? this.column.field : this.formattedLabel);
    },
    hasTooltip() {
      return !!this.formattedTooltip;
    },
    isTooltipActive() {
      return this.showTooltip && !!this.column?.tooltip;
    },
    tooltipMessage() {
      return this.showTooltip && this.column ? this.column.edit_tooltip : '';
    }
  },
  methods: {
    getClasses({ errors = [] }) {
      return errors.length ? ['is-danger'] : [];
    },
    hasValidationErrors({ errors = [], untouched }) {
      return !!errors.length && !untouched;
    },
    onEnter(...args) {
      this.$emit('on-enter', ...args);
    },
    onKeyUp(...args) {
      this.$emit('on-key-up', ...args);
    },
    onBlur(...args) {
      this.$emit('on-blur', ...args);
    }
  }
};
